module.exports = __webpack_public_path__ + "static/media/winner_hart.01deb83a.svg";